var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNoAccounts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 124,
    viewBox: "0 0 120 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_76_12677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 122.009L36.5385 40.3721H82.4038L114 122.009H8Z",
    fill: "url(#paint0_linear_76_12677)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M33.3364 28.2225C33.2521 16.5003 45.0045 6.94726 59.5369 6.86383C74.0693 6.7804 85.948 16.2082 85.9901 27.8888L33.3364 28.2225Z",
    fill: "#EABBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2888 27.8894C44.2466 19.8381 51.576 13.247 60.7167 13.2053C69.8574 13.1636 77.271 19.6296 77.3132 27.7225L44.2888 27.8894Z",
    fill: "url(#paint1_linear_76_12677)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3366 28.2224L19.1411 33.6455L99.9751 33.1866L86.2851 27.8887L33.3366 28.2224Z",
    fill: "url(#paint2_linear_76_12677)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.184 33.1716L16.7967 33.7009C15.806 33.707 15.0079 34.515 15.014 35.5057C15.0202 36.4964 15.8283 37.2946 16.8189 37.2885L103.206 36.7592C104.197 36.7531 104.995 35.9451 104.989 34.9544C104.983 33.9637 104.175 33.1655 103.184 33.1716Z",
    fill: "#5D5189"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2245 44.4499C42.2245 44.4499 24.7014 40.7789 20.2363 37.233L46.4368 37.0662L99.4696 36.7324C99.4696 36.7324 88.1386 44.3665 77.5657 44.2413C77.5657 44.2413 77.4393 47.8289 73.3113 47.8289C69.1832 47.8706 46.7738 47.9958 46.7738 47.9958C46.7738 47.9958 41.6769 47.1615 41.6769 44.3248",
    fill: "url(#paint3_linear_76_12677)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M61.8115 13.1631C61.8115 13.1631 70.9943 18.7531 67.4139 27.722L75.7963 27.6803C75.7963 27.6803 75.4172 15.6661 61.8115 13.1631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M47.3635 24.4686C47.3214 24.3017 47.2793 24.1348 47.2793 23.968C47.1108 20.9644 50.944 16.2088 54.0611 15.9585C55.2827 15.875 56.757 17.0014 56.0409 18.2946C55.1142 20.0049 53.9347 21.5484 52.7132 23.0502C51.8286 24.1765 50.6913 26.1372 48.9642 25.7618C48.206 25.6366 47.6163 25.1777 47.3635 24.4686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M59.5793 24.1344C59.5793 25.3024 58.6526 26.2619 57.431 26.2619C56.2515 26.2619 55.2827 25.3441 55.2827 24.1344C55.2827 22.9663 56.2094 22.0068 57.431 22.0068C58.6104 22.0486 59.5793 22.9663 59.5793 24.1344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5041 34.6629L17.0244 34.7147C16.6558 34.7169 16.3588 35.0176 16.3611 35.3862C16.3634 35.7548 16.6641 36.0518 17.0327 36.0496L25.5124 35.9978C25.8811 35.9956 26.178 35.6949 26.1757 35.3263C26.1734 34.9577 25.8728 34.6607 25.5041 34.6629Z",
    fill: "url(#paint4_linear_76_12677)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3318 34.663L31.852 34.7147C31.4834 34.7169 31.1864 35.0176 31.1887 35.3862C31.191 35.7548 31.4917 36.0518 31.8603 36.0496L40.3401 35.9979C40.7087 35.9957 41.0057 35.695 41.0034 35.3264C41.0011 34.9578 40.7004 34.6608 40.3318 34.663Z",
    fill: "url(#paint5_linear_76_12677)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2009 34.663L46.7212 34.7147C46.3525 34.7169 46.0556 35.0176 46.0579 35.3862C46.0601 35.7548 46.3608 36.0518 46.7295 36.0496L55.2092 35.9979C55.5778 35.9957 55.8748 35.695 55.8725 35.3264C55.8702 34.9578 55.5695 34.6608 55.2009 34.663Z",
    fill: "url(#paint6_linear_76_12677)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.029 34.705L61.5493 34.7567C61.1807 34.7589 60.8837 35.0596 60.886 35.4282C60.8883 35.7968 61.189 36.0938 61.5576 36.0916L70.0373 36.0399C70.406 36.0376 70.7029 35.737 70.7006 35.3684C70.6983 34.9997 70.3977 34.7027 70.029 34.705Z",
    fill: "url(#paint7_linear_76_12677)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8987 34.58L76.4189 34.6317C76.0503 34.6339 75.7533 34.9346 75.7556 35.3032C75.7579 35.6718 76.0586 35.9688 76.4272 35.9666L84.907 35.9149C85.2756 35.9126 85.5726 35.612 85.5703 35.2434C85.568 34.8747 85.2673 34.5777 84.8987 34.58Z",
    fill: "url(#paint8_linear_76_12677)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7263 34.4549L91.2466 34.5067C90.8779 34.5089 90.581 34.8096 90.5833 35.1782C90.5855 35.5468 90.8862 35.8438 91.2549 35.8416L99.7346 35.7899C100.103 35.7876 100.4 35.4869 100.398 35.1183C100.396 34.7497 100.095 34.4527 99.7263 34.4549Z",
    fill: "url(#paint9_linear_76_12677)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61,
    cy: 120.414,
    rx: 30,
    ry: 4,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 57,
    width: 54,
    height: 54,
    rx: 16,
    fill: "url(#paint10_linear_76_12677)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7498 75.4441H49.3054C47.993 75.4441 46.7509 74.8758 45.8908 73.9179C46.7311 72.9798 47.9518 72.3886 49.3054 72.3886H76.8054C78.8037 72.3794 78.8022 69.3406 76.8054 69.333H49.3054C45.0872 69.333 41.6665 72.7537 41.6665 76.9719V92.2497C41.6665 96.4679 45.0872 99.8886 49.3054 99.8886H73.7498C76.2814 99.8886 78.3332 97.8368 78.3332 95.3052V80.0275C78.3332 77.4959 76.2814 75.4441 73.7498 75.4441ZM72.2221 89.1941C70.2237 89.185 70.2237 86.1477 72.2221 86.1386C74.2204 86.1477 74.2204 89.185 72.2221 89.1941Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_76_12677",
    x1: 61,
    y1: 40.3721,
    x2: 61,
    y2: 122.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_76_12677",
    x1: 60.8009,
    y1: 13.2051,
    x2: 60.8009,
    y2: 27.8894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#973BA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF53FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_76_12677",
    x1: 59.5581,
    y1: 27.8887,
    x2: 59.5581,
    y2: 33.6455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAADEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDE8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_76_12677",
    x1: 67.9999,
    y1: 48.2,
    x2: 67.9999,
    y2: 36.2531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAADEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDE8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_76_12677",
    x1: 16.3629,
    y1: 35.6761,
    x2: 26.1775,
    y2: 35.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_76_12677",
    x1: 31.1905,
    y1: 35.6761,
    x2: 41.0052,
    y2: 35.6151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_76_12677",
    x1: 46.0597,
    y1: 35.6761,
    x2: 55.8743,
    y2: 35.6151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_76_12677",
    x1: 60.8878,
    y1: 35.7181,
    x2: 70.7024,
    y2: 35.6571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_76_12677",
    x1: 75.7574,
    y1: 35.5931,
    x2: 85.5721,
    y2: 35.5321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_76_12677",
    x1: 90.5851,
    y1: 35.4681,
    x2: 100.4,
    y2: 35.4071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C61CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_76_12677",
    x1: 60,
    y1: 57,
    x2: 60,
    y2: 113.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E600EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9002FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_76_12677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 124,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoAccounts);
export default __webpack_public_path__ + "static/media/icon_no_accounts.6b43b1cbd896d577e7aab1fee073d68a.svg";
export { ForwardRef as ReactComponent };